import React from 'react'
import {
    SwipeableDrawer,
    Button,
    Box,
} from "@mui/material";
import CalendarFilter from './CalenderPopup';

export const CalenderDrawer = ({filter,handleFilter,handleDateFilter, t}) => {
    return (
        <SwipeableDrawer
            className="filterDrawer"
            anchor="bottom"
            open={filter}
            onClose={handleFilter}
            onOpen={handleFilter}
            disableBackdropTransition={false} >
            <Box className="filterBox">
                <h4>Filter</h4>
                <CalendarFilter t={t} handleDateFilter={handleDateFilter} handleFilter={handleFilter} />

                <Box display="flex" justifyContent="flex-end" gap={2} className="applyButton">
                    <Button onClick={handleFilter}>
                        Apply Filter
                    </Button>
                </Box>
            </Box>
        </SwipeableDrawer>
    )
}
